import { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Media, Row } from 'react-bootstrap'
import Tappable from 'react-tappable/lib/Tappable'
import { map, range } from 'lodash'
import classNames from 'classnames'

import Image from 'components/image'
import Link from 'components/link'
import { addOrReplaceImageTransform } from 'lib/cloudinary'
import * as blUrls from 'lib/urls'
import { ldGetFlag } from 'lib/launchDarkly/ldGetFlag'

import ProductCard from '../product-card'
import ProductCardGhost from '../product-card-ghost'
import ProductCardV2 from '../ProductCardV2'
import css from './product-grid.scss'

// Grid flow issue with the second insertion - fix after launch
const GUIDE_INSERTIONS = [6] // , 32]

class ProductGrid extends Component {
  constructor(props) {
    super(props)
    this.isInProductCardExperiment =
      ldGetFlag('24b-ex-shop-product-card-optimizations', 'control') ===
      'variation1'
  }

  maybeRenderGuide(idx) {
    const { guides } = this.props
    if (!guides) return null

    let guide
    if (GUIDE_INSERTIONS.indexOf(idx) != -1) {
      guide = guides[GUIDE_INSERTIONS.indexOf(idx)]
    }

    return guide && <GuideCard className={css.guideCard} post={guide} />
  }

  render() {
    const { activeSlugSet, className, productCards } = this.props
    return (
      <div className={className}>
        <Row>
          {productCards
            ? map(productCards, (card, idx) => {
                const guideComponent = this.maybeRenderGuide(idx)
                const guidePush =
                  guideComponent && GUIDE_INSERTIONS.indexOf(idx) % 2 == 0
                    ? 4
                    : 0
                // Push/pull to swap placement on mobile and make sure that there
                // is no row with only 1 product card by itself
                const { productBadge, ...otherCardProps } = card
                let badgeComponent
                if (productBadge) {
                  badgeComponent = (
                    <ProductCard.Badge
                      imgUrl={productBadge.imageUrl}
                      alt={productBadge.title}
                    />
                  )
                }
                return [
                  guideComponent && (
                    <Col xs={12} sm={8} smPush={guidePush}>
                      {guideComponent}
                    </Col>
                  ),
                  <Col
                    xs={6}
                    sm={4}
                    smPull={guidePush ? 12 - guidePush : 0}
                    key={`${card.title}-${idx}`}
                  >
                    {this.isInProductCardExperiment ? (
                      /* eslint-disable-next-line react/jsx-props-no-spreading */
                      <ProductCardV2
                        {...otherCardProps}
                        slugSet={activeSlugSet}
                      />
                    ) : (
                      <ProductCard
                        className="mvs"
                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                        {...otherCardProps}
                        badgeComponent={badgeComponent}
                        position={idx + 1}
                        slugSet={activeSlugSet}
                      />
                    )}
                  </Col>,
                ]
              })
            : map(range(0, 6), (idx) => (
                <Col xs={6} sm={4} key={idx}>
                  <ProductCardGhost />
                </Col>
              ))}
        </Row>
      </div>
    )
  }
}

ProductGrid.propTypes = {
  className: PropTypes.string,
  guides: PropTypes.array,
  productCards: PropTypes.array,
  activeSlugSet: PropTypes.array,
}

ProductGrid.defaultProps = {
  className: '',
  guides: [],
  productCards: [],
  activeSlugSet: [],
}

const GuideCard = ({ className, post }) => (
  <Tappable
    component={Link}
    className="text-body"
    url={blUrls.helloBabyPostPath(post.slug)}
  >
    <Media className={classNames(className, 'position-rel')}>
      <div className="hover-overlay hover-darken">
        {/* width % attempts to closely match the width of the product card */}
        <Media.Left className="pan" style={{ width: '44%' }}>
          <Image
            src={addOrReplaceImageTransform(
              post.featuredImage.url,
              'c_fill,g_auto:face,h_900,w_500'
            )}
            alt={post.title}
            style={{ width: '100%' }}
          />
        </Media.Left>
        <Media.Body className="bbs brs bts mbm">
          <div className="center-y pal">
            <div className={classNames('h6', css.guideCardLabel)}>Guide</div>
            <div className={`media-heading ${css.guideCardTitle}`}>
              {post.title}
            </div>
            <p className={css.guideCardTeaser}>{post.teaser}</p>
            {/* Make this look like a link, but in fact the entire card is clickable */}
            <p className="h7 text-brand-info text-uppercase">Read More</p>
          </div>
        </Media.Body>
      </div>
    </Media>
  </Tappable>
)

GuideCard.propTypes = {
  className: PropTypes.string,
  post: PropTypes.object.isRequired,
}

GuideCard.defaultProps = {
  className: '',
}

export default ProductGrid
export { GuideCard }
